import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  data: [],
  category: "Overall",
  view: "top",
  totalRecords: 0,
};

const commodityComplianceSlice = createSlice({
  name: "commodityCompliance",
  initialState,
  reducers: {
    fetchCompliance: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    
    fetchComplianceSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload?.commodities || [];
      state.totalRecords = action.payload?.totalRecords || 0;
    },
    
    fetchComplianceFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    
    setView: (state, action) => {
      state.view = action.payload;
    },
  },
});

export const { actions, reducer } = commodityComplianceSlice;
export const sliceKey = "commodityCompliance";